import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { environment } from 'src/environments/environment';
import { ReceiptDialogComponent } from '../dialog/receipt-dialog/receipt-dialog.component';

@Injectable({
  providedIn: 'root'
})
export class PaymentService {
  paymentInfo: any;
  paymentKey: any;
  actionUrl = '';
  
  private isMounted: boolean = false;
  constructor(
    private dialog: MatDialog
  ) { }
  init(): void {
    this.load([environment.checkout_popup_js, environment.checkout_popup_css]);
  }
  private load(urls: string[]): void {
    if (this.isMounted) return;
    let element;
    urls.forEach(url => {
      if (url.endsWith("js")) {
        element = document.createElement('script');
        element.src = url;
        element.type = 'text/javascript';
        element.async = true;
        document.body.appendChild(element);
      } else if (url.endsWith("css")) {
        element = document.createElement('link');
        element.rel = "stylesheet";
        element.href = url;
        document.head.appendChild(element);
      }
    });
    this.isMounted = true;
  }
  openReceiptDialog(data): MatDialogRef<ReceiptDialogComponent> {
    return this.dialog.open<ReceiptDialogComponent>(ReceiptDialogComponent, {
      width: '1000px',
      data: {
        amounts: data.amounts,
        ...data
      }
    });
  }
}
